import { useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import {
  Paper,
  Stack,
  Typography,
  Box,
  Button,
  TextField,
} from "@mui/material";
import Feedback from "../../shared/api/FeedbackApi";
import "./FeedbackPage.css";

export default function FeedbackPage() {
  const [message, setMessage] = useState("");
  const [author, setAuthor] = useState("");
  const [sent, setSent] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();

  const valid = message.trim().length > 0;

  return (
    <div className="column rank5background feedbackPage">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          width: "100%",
          py: 4,
        }}
      >
        <Paper
          sx={{
            maxWidth: 500,
            width: { xs: "90vw", sm: 500 },
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
          }}
        >
          {!sent ? (
            <Stack spacing={2.5}>
              <Typography variant="h5" fontWeight={700}>
                {t("feedback")}
              </Typography>
              <TextField
                multiline
                minRows={5}
                maxRows={10}
                placeholder="..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                inputProps={{ maxLength: 5000 }}
                fullWidth
              />
              <Typography variant="h6" fontWeight={600}>
                {t("from")}
              </Typography>
              <TextField
                placeholder={t("secret_admirer")}
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                inputProps={{ maxLength: 40 }}
                fullWidth
                size="small"
              />
              <Stack direction="row" justifyContent="space-between" sx={{ pt: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => history.push("")}
                  sx={{ borderRadius: 2, fontWeight: 600 }}
                >
                  {t("back")}
                </Button>
                <Button
                  variant="contained"
                  disabled={!valid}
                  onClick={() => {
                    Feedback.submitFeedback(message, author);
                    setSent(true);
                  }}
                  sx={{ borderRadius: 2, fontWeight: 600, px: 4 }}
                >
                  {t("send")}
                </Button>
              </Stack>
            </Stack>
          ) : (
            <Stack spacing={3} alignItems="center" sx={{ py: 3 }}>
              <Typography variant="h5" fontWeight={700} textAlign="center">
                {t("thx4Impro")}
              </Typography>
              <Typography variant="h6" color="text.secondary" textAlign="center">
                {t("get_back")}
              </Typography>
              <Button
                variant="contained"
                size="large"
                onClick={() => history.push("")}
                sx={{
                  borderRadius: 3,
                  px: 5,
                  py: 1.5,
                  fontWeight: 700,
                  fontSize: "1.1rem",
                }}
              >
                Back
              </Button>
            </Stack>
          )}
        </Paper>
      </Box>
    </div>
  );
}
